import React from 'react';
import PropTypes from 'prop-types';
import { DEVICE } from '@/constants';
import './style.less';

const S1 = ({ os }) => (
  <React.Fragment>
    { os !== DEVICE.MOBILE
      && (
        <React.Fragment>
          <div className="light4" />
        </React.Fragment>
      )
    }
    <div className="light1" />
    <div className="light2" />
    <div className="light3" />
    <div className="ice1" />
    <div className="ice2" />
    <div className="ice3" />
    <div className="ice4" />
    <div className="snow1" />
    <div className="snow2" />
    <div className="snow3" />
    <div className="snow4" />
    <div className="snow5" />
    <div className="snow6" />
    { os !== DEVICE.PC
      && (
        <React.Fragment>
          <div className="snow7" />
          <div className="snow8" />
          <div className="snow9" />
          <div className="snow10" />
        </React.Fragment>
      )
    }
    { os === DEVICE.PAD
      && (
        <React.Fragment>
          <div className="snow11" />
          <div className="snow12" />
          <div className="snow13" />
          <div className="snow14" />
        </React.Fragment>
      )
    }
    <div className="deer" />
    <div className="bell" />
    <div className="candy" />
    <div className="tree" />
    <div className="snowman" />
    <div className="island" />
  </React.Fragment>
);

S1.propTypes = {
  os: PropTypes.string,
};
export default S1;
